import { SvgIcon } from '@mui/material';

export default function MicrophoneIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 17 25" style={{ ...props.style }}>
      <path d="M8.5,17.99c2.57,0,4.66-2.23,4.66-4.97v-7.81C13.16,2.47,11.07.24,8.5.24S3.85,2.47,3.85,5.22v7.81c0,2.74,2.09,4.97,4.66,4.97Z" />
      <path d="M16.82,13.34c0-.55-.45-1-1-1h0c-.55,0-1,.45-1,1,0,3.48-2.83,6.31-6.31,6.32-3.48,0-6.31-2.83-6.31-6.32,0-.55-.45-1-1-1s-1,.45-1,1c0,4.25,3.2,7.76,7.31,8.25v1.72h-2.66c-.55,0-1,.45-1,1s.45,1,1,1h7.31c.55,0,1-.45,1-1s-.45-1-1-1h-2.66v-1.72c4.12-.5,7.31-4.01,7.31-8.26Z" />
    </SvgIcon>
  );
}
